const NationalRankings = [
    {
        header: "Ranking over the years",
        data: [
            { title: "Rank 2023", value: "1" },
            { title: "Rank 2022", value: "1" },
     
        ]
    },
];

export default NationalRankings;
